import { Component, ViewChild, ElementRef, HostListener } from '@angular/core';
import { HttpEventType, HttpEvent } from '@angular/common/http';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { TasksService } from '../services/tasks.service';

import { requestFullScreen, requestExitFullScreen } from '../fullscreen';
import { Base64ToBinary } from '../base64ToBinary';

import * as THREE from 'three-full';

import { Zlib } from 'three/examples/js/libs/inflate.min';
(window as any).Zlib = Zlib;

@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent {

  private renderer: THREE.WebGLRenderer;

  private perspectiveCamera: THREE.PerspectiveCamera;

  private orbitControls: THREE.OrbitControls;

  private initGroup: THREE.Group;
  public scene: THREE.Scene;

  public bContents = false;
  public loading = false;
  private modelID: string;

  contents: THREE.Group;

  fileDownloadProgress: string;
  backgroundImg: any;
  help: boolean = false;
  isFullScreen: boolean = false;

  @ViewChild('canvas', { static: true }) private canvasRef: ElementRef;
  @ViewChild('viewer', { static: true }) private viewerRef: ElementRef;

  constructor(
    private tasksService: TasksService,
    private route: ActivatedRoute,
    private router: Router,
  ) {

    // Get model ID
    this.modelID = this.route.snapshot.paramMap.get('id');
    // console.log("modelID " + this.modelID);

    // if (this.modelID) {
    //   this.tasksService.getMiniature(this.modelID).subscribe(response => {
    //     this.backgroundImg = response;
    //   });
    // } else {
    //   // Not found model ID
    //   this.router.navigate(['/']);
    // }

    this.render = this.render.bind(this);
  }

  private get canvas(): HTMLCanvasElement {
    return this.canvasRef.nativeElement;
  }

  loadModel() {

    (<any>window).gtag('event', 'click', {
      'event_category': 'Play_Button',
      'event_label': this.modelID,
      'value': 1
    });

    // WebGL Render
    this.InitWebGLRender();

    this.StartWebGLRendering();
    this.addControls();

    this.scene.add(this.initGroup);
    // this.render();

    if (this.modelID) {
      this.loading = true;
      this.tasksService.LoadModel(this.modelID).subscribe((event: HttpEvent<any>) => {

        switch (event.type) {
          case HttpEventType.DownloadProgress:
            this.fileDownloadProgress = `${Math.round(100 * event.loaded / event.total)}`;
            break;
          case HttpEventType.Response:
            this.CreateModel(event.body);
            break;
          default:
            break;
        }
      }, () => { }, () => {
        // this.Helpers();
      });
    }
  }

  private InitWebGLRender() {

    this.scene = new THREE.Scene();

    this.initGroup = new THREE.Group();
    this.initGroup.name = 'initGroup';

    this.contents = new THREE.Group();
    this.contents.name = 'Contents';

    // Setup Camera
    this.perspectiveCamera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 500000);

    this.perspectiveCamera.up = new THREE.Vector3(0, 1, 0);

    // Set position and look at
    this.perspectiveCamera.position.x = -128;
    this.perspectiveCamera.position.y = 64;
    this.perspectiveCamera.position.z = 128;

    this.scene.background = new THREE.Color(0xa0a0a0);

    // Add Light
    var hemiLight = new THREE.HemisphereLight(0xcccccc, 0xaaaaaa);
    // // var hemiLight = new THREE.HemisphereLight(0xfff780, 0xffc66b, .25);
    hemiLight.position.set(0, 100, 0);
    this.initGroup.add(hemiLight);

    var dirLight = new THREE.DirectionalLight(0xaaaaaa, 2.25);
    dirLight.position.set(-50, 40, 50);
    
    var dirLight1 = new THREE.DirectionalLight(0xaaaaaa, 2.25);
    dirLight1.position.set(50, 40, -50);

    // this.initGroup.add(dirLight);
    this.initGroup.add(dirLight, dirLight1);
  }

  private Helpers() {
    /* Grid Helper */
    const size = 1024 * 4;
    const divisions = 256;

    const gridHelper = new THREE.GridHelper(size, divisions);
    gridHelper.position.set(0, 0, -0.5);

    this.initGroup.add(gridHelper);
    // this.render();
  }

  private StartWebGLRendering() {

    this.renderer = new THREE.WebGLRenderer({ canvas: this.canvas, antialias: true, alpha: true });
    this.renderer.setPixelRatio(devicePixelRatio);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    // this.renderer.setClearColor(0xffffff, 1);
    this.renderer.setClearColor(0x000000, 0.0);
    // this.scene.fog = new THREE.Fog( 0xa0a0a0, 500, 1000 );
    // this.renderer.autoClear = true;
    // this.render();
  }

  // WebGL Render
  public render() {
    this.renderer.render(this.scene, this.perspectiveCamera);
  }

  private addControls() {

    // Camera controls
    this.orbitControls = new THREE.OrbitControls(this.perspectiveCamera, this.renderer.domElement);

    this.orbitControls.rotateSpeed = 1.0;
    this.orbitControls.zoomSpeed = 0.75;
    this.orbitControls.enablePan = true;
    this.orbitControls.enableKeys = false;
    // // this.controls.minPolarAngle = Math.PI / 2;
    this.orbitControls.maxPolarAngle = Math.PI / 2;

    this.orbitControls.addEventListener('change', this.render);
  }

  // private CreateModel(data: any) {

  //   const manager = new THREE.LoadingManager();

  //   const loader = new THREE.FBXLoader(manager);

  //   const ArrayBuffer = new Base64ToBinary().decodeArrayBuffer(data.model);
  //   const object = loader.parse(ArrayBuffer, data.files);

  //   manager.onStart = function (url, itemsLoaded, itemsTotal) {
  //     // console.log('Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
  //   };

  //   // Load manager
  //   manager.onLoad = () => {
  //     // console.log('Loading complete!');
  //     // this.onResize();

  //     this.bContents = true;
  //     this.loading = false;

  //     this.fitCameraToObject(object);
  //     this.render();
  //   };

  //   manager.onProgress = (url, itemsLoaded, itemsTotal) => {
  //     // console.log('Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
  //   };

  //   manager.onError = (url) => {
  //     console.log('There was an error loading ' + url);
  //   };

  //   object.traverse((child) => {

  //     if (child.isMesh) {
  //       child.material.side = THREE.DoubleSide;
  //       child.material.vertexColors = THREE.NoColors;

  //       const oldMat = child.material;

  //       child.material = new THREE.MeshPhongMaterial({
  //         color: oldMat.color,
  //         normalMap: oldMat.normalMap,
  //         map: oldMat.map,
  //         side: THREE.DoubleSide,
  //         vertexColors: THREE.NoColors,
  //         // specular: new THREE.Color(0.1, 0.1, 0.1)
  //         // roughness: 0.5,
  //         // metalness: 0.5
  //       });
  //     }

  //     if (child.type === 'Group') {

  //       // console.log('child: ', child);
  //       // child.scale.set(1, 1, 1);
  //       // child.material.side = THREE.DoubleSide;
  //     }
  //   });

  //   // object.scale.set(data.position.scale[0], data.position.scale[1], data.position.scale[2]);
  //   object.scale.set(0.1, 0.1, 0.1);

  //   this.contents.add(object);
  //   this.scene.add(this.contents);
  //   // this.render();

  //   // this.fitCameraToObject(object);
  // }

  private CreateModel(data: any) {
    const manager = new THREE.LoadingManager();
    const loader = new THREE.GLTFLoader(manager);

    try {
      const arrayBuffer = new Base64ToBinary().decodeArrayBuffer(data.model);

      // Debug: Check GLB header
      // const header = new Uint8Array(arrayBuffer, 0, 12);
      // console.log("GLB Header:", Array.from(header).map(b => b.toString(16).padStart(2, '0')));

      loader.parse(arrayBuffer, '', (gltf) => {
        const object = gltf.scene;

        object.traverse((child) => {
          if (child.isMesh) {
            // Just ensure double-sided rendering
            child.material.side = THREE.DoubleSide;
          }
        });

        object.scale.set(0.1, 0.1, 0.1);
        this.contents.add(object);
        this.scene.add(this.contents);
        this.fitCameraToObject(object);
        this.bContents = true;
        this.loading = false;
      }, (error) => {
        console.error("GLTFLoader failed:", error);
      });
    } catch (error) {
      console.error("Model decoding failed:", error);
    }
  }

  fitCameraToObject(object, fitOffset = 1.2) {

    const box = new THREE.Box3();

    box.expandByObject(object);

    const size = box.getSize(new THREE.Vector3());
    const center = box.getCenter(new THREE.Vector3());

    const maxSize = Math.max(size.x, size.y, size.z);
    const fitHeightDistance = maxSize / (2 * Math.atan(Math.PI * this.perspectiveCamera.fov / 360));
    const fitWidthDistance = fitHeightDistance / this.perspectiveCamera.aspect;
    const distance = fitOffset * Math.max(fitHeightDistance, fitWidthDistance);

    const direction = this.orbitControls.target.clone()
      .sub(this.perspectiveCamera.position)
      .normalize()
      .multiplyScalar(distance);

    this.orbitControls.maxDistance = distance * 10;
    this.orbitControls.minDistance = distance / 10;
    this.orbitControls.target.copy(center);

    this.perspectiveCamera.near = distance / 100;
    this.perspectiveCamera.far = distance * 100;
    this.perspectiveCamera.updateProjectionMatrix();

    this.perspectiveCamera.position.copy(this.orbitControls.target).sub(direction);

    this.orbitControls.update();
  }

  toggleFullScreen(): void {

    this.isFullScreen = !this.isFullScreen;

    if (this.isFullScreen) {
      requestFullScreen(this.viewerRef.nativeElement);
      (<any>window).gtag('event', 'click', {
        'event_category': 'FullScreen_Button',
        'event_label': this.modelID,
        'value': 2
      });
      //   this.engineService.fitData();
    } else {
      requestExitFullScreen(window.document);
      //   this.engineService.fitData();
    }
  }

  toggleHelp(): void {
    this.help = !this.help;
    if (this.help) {
      (<any>window).gtag('event', 'click', {
        'event_category': 'Help_Button',
        'event_label': this.modelID,
        'value': 3
      });
    }
  }

  lugar() {
    (<any>window).gtag('event', 'click', {
      'event_category': 'LugAR_Button',
      'event_label': this.modelID,
      'value': 4
    });
  }

  @HostListener('fullscreenchange') onFullscreenChange() {
    if (document.fullscreenElement) {
      // Entered full-screen mode
      this.isFullScreen = true;
      this.fitCameraToObject(this.scene.children[1]);
    } else {
      // Leaving full-screen mode
      this.isFullScreen = false;
      this.fitCameraToObject(this.scene.children[1]);
    }

  }

  @HostListener('dblclick') onDoubleClicked() {
    if (this.scene !== undefined && this.scene.children[1] !== undefined) {
      this.fitCameraToObject(this.scene.children[1]);
    }
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event: Event) {
    if (this.perspectiveCamera) {
      this.perspectiveCamera.aspect = window.innerWidth / window.innerHeight;
      this.perspectiveCamera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);

      this.fitCameraToObject(this.scene.children[1]);
    }
  }
}
